import Clipboard from 'clipboard'
// import { MessageUtil } from '../../utils/tip'
import { MessageUtil } from '@cndinfo/cube-web-utils'

if (!Clipboard) {
  throw new Error('you should npm install `clipboard` --save at first ')
}

// 复制文本/标签
const copy = {
  bind(el, binding) {
    // console.log('bindel--', el)
    // console.log('el.children--', el.children)
    // console.log('el.children--', el.children[0].style)
    let flagCopy = true
    if (el.className.indexOf('el-input') > -1 && el.children && el.children.length) {
      if (el.children[0].disabled || el.children[0].readOnly) {
        // el.children[0].style.cursor = 'move'
        // el.children[0].className = 'cursor2'
      } else {
        flagCopy = false
      }
    }
    // 可复制DOM添加自定义鼠标样式
    if (flagCopy && el.className.indexOf('cursor-copy') === -1) {
      el.className += ' cursor-copy'
    }
    // console.log('binding.value--', binding.value)
    // console.log('flagCopy--', flagCopy)
    flagCopy && (el.onclick = function(e) {
      const clipboard = new Clipboard(e.target, {
        text: () => {
          return binding.value || e.target.value || e.target.innerText
        }
      })
      clipboard.on('success', () => {
        MessageUtil.success(this.$t('tips.duplicated'))
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        MessageUtil.error(this.$t('grid.others.copyFailure'))
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(e)
    })
  },
  update(el, binding) {
    // console.log('el--', el)
    // console.log('el.children--', el.children)
    // console.log('el.children--', el.children[0].style)
    let flagCopy = true
    if (el.className.indexOf('el-input') > -1 && el.children && el.children.length) {
      // console.log('el.children[0]--', el.children)
      if (el.children[0].disabled || el.children[0].readOnly) {
        // el.children[0].style.cursor = 'move'
        // el.children[0].className = 'cursor2'
      } else {
        flagCopy = false
      }
    }
    // 可复制DOM添加自定义鼠标样式
    if (flagCopy && el.className.indexOf('cursor-copy') === -1) {
      el.className += ' cursor-copy'
    }
    // console.log('binding.value--', binding.value)
    // console.log('flagCopy--', flagCopy)
    flagCopy && (el.onclick = function(e) {
      const clipboard = new Clipboard(e.target, {
        text: () => {
          return binding.value || e.target.value || e.target.innerText
        }
      })
      clipboard.on('success', () => {
        MessageUtil.success(this.$t('tips.duplicated'))
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        MessageUtil.error(this.$t('grid.others.copyFailure'))
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(e)
    })
  }
}

export default copy
